import React, {useEffect, useState} from "react";
import { getFetch } from "../../../../../fetch/fetch";

const ManageContractVariable : React.FC<any> = (props) => {

    useEffect(() => {
        
        getTotalEmployeeRoles();

    }, []);

    const getTotalEmployeeRoles = async () => {

        try{

            const result = await getFetch("/dashboard/report/gettotalemployeeroles");

            console.log(result);

        }catch(e){
            console.log(e);
        }

    }

    return (
        <div>
            12345
        </div>
    )

}

export default ManageContractVariable;